module.exports = __webpack_public_path__ + "static/media/icon_volleyball_ball.a909f24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_volleyball_ball.png
// module id = 529
// module chunks = 0